import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import axios from 'axios';

const Footer = () => {
  const { t } = useTranslation();

  const [tagline, settagline] = useState("");
  const [sitename, setsitename] = useState("");
  const handleLoad =async  () => {
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }

        await axios.get(process.env.REACT_APP_API_URL + 'getUserDetails', { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {

                    settagline(res.data.logosettings[0].tagline);
                    setsitename(res.data.logosettings[0].logo_title);

                } else {
                }
            })
            .catch(function (error) {
            });
    }

  useEffect(() => {
    handleLoad();
  }, []);

  return (
    <div className="footer">
      <div className="copyright">
        <p className="float-left">
          © {new Date().getFullYear()} {sitename} {tagline} &amp; {t('DEVELOP_BY')}
          <Link to="/dashboard" rel="noreferrer">
            &nbsp;{sitename}&nbsp;
          </Link>
        </p>
        <ul className="bottom-links">
          <li>
            <a href={process.env.REACT_APP_TERMS_URL || "/terms"} target="_blank" rel="noopener noreferrer">
              {t('TERMS_TITLE')}
            </a>
          </li>
          <li>
            <a href={process.env.REACT_APP_PRIVACY_POLICY_URL || "/privacypolicy"} target="_blank" rel="noopener noreferrer">
              {t('PRIVACY_TITLE')}
            </a>
          </li>
          <li> <Link to="/contact-us">{t('CONTACT_US_TITLE')}</Link></li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;
